import BlogImage from "@/assets/images/blog-dummy-img.webp";
import FBIcon from "@/assets/images/FB.svg";
import Xcon from "@/assets/images/X.svg";
import InIcon from "@/assets/images/IN.svg";
import Instacon from "@/assets/images/INSTA.svg";
import YTcon from "@/assets/images/YT.svg";

import DLE8400BE from "@/assets/ManualPLPImages/DLE8400BE.webp"
import PTD70EBPTDG from "@/assets/ManualPLPImages/PTD70EBPTDG.webp"
import PTW705BPTDG from "@/assets/ManualPLPImages/PTW705BPTDG.webp"
import WGB246AXUC from "@/assets/ManualPLPImages/WGB246AXUC.webp"
import WGB24600UC from "@/assets/ManualPLPImages/WGB24600UC.webp"
import WQB245AXUC from "@/assets/ManualPLPImages/WQB245AXUC.webp"
import WQB245B0UC from "@/assets/ManualPLPImages/WQB245B0UC.webp"
import WT8400CB from "@/assets/ManualPLPImages/WT8400CB.webp"
// import PTW705BPTDG_PTD70EBPTDG from "@/assets/ManualPLPImages/PTW705BPTDG-PTD70EBPTDG.webp"
// import WGB246AXUC_WQB245AXUC from "@/assets/ManualPLPImages/WGB246AXUC-WQB245AXUC.webp"
// import WGB24600UC_WQB245B0UC from "@/assets/ManualPLPImages/WGB24600UC-WQB245B0UC.webp"
// import WT8400CB_DLE8400BE from "@/assets/ManualPLPImages/WT8400CB-DLE8400BE.webp"



export const StaticLink = [
  {
    href: "/about-us",
    label: "About Airport Appliance",
  },
  {
    href: "/careers",
    label: "Careers",
  },
  {
    href: "/authorized-online-dealer",
    label: "Authorized Online Dealer",
  },
  {
    href: "/terms-and-conditions",
    label: "Terms and Conditions",
  },
  {
    href: "/privacy-policy-cookie-restriction-mode",
    label: "Privacy Policy",
  },
  {
    href: "/sms-terms",
    label: "SMS terms",
  },
  {
    href: "/california-privacy-rights",
    label: "California Privacy Rights",
  },
  {
    href: "/accessibility-statement",
    label: "Accessibility",
  },
  {
    href: "/contact",
    label: "Contact Us",
  },
];

export const ResourcesLink = [
  {
    href: "/appliance-delivery",
    label: "Appliance Delivery",
  },
  {
    href: "/appliance-installation",
    label: "Appliance Installation",
  },
  {
    href: "/delivery-and-customer-pickup",
    label: "Customer Pickup",
  },
  {
    href: "/return-policy",
    label: "Return Policy",
  },
  {
    href: "/warranty-support",
    label: "Warranty Support",
  },
  {
    href: "/financing",
    label: "Financing",
  },
  // {
  //   href: "/",
  //   label: "Coupons",
  // },
  {
    // href: "/low-price-guarantee",
    href: "/low-price-guarantee",
    label: "Low Price Guarantee",
  },
  {
    href: "/donation",
    label: "Donation",
  },
  // {
  //   href: "/learning-center",
  //   label: "Learning Center",
  // },
  {
    href: "/blog",
    label: "Blog",
  },
  {
    href: "/events",
    label: "Events",
  }
];

export const NavigationLink = [
  { href: "/products", label: "Products" },
  { href: "/kitchen-packages", label: "Packages" },
  { href: "/package-detail", label: "Package Detail" },
];
export const shoppingToolLinks = [
  {
    href: "/brands",
    label: "Shop by Brands",
  },
  {
    href: "/top-deals",
    label: "Top Deals",
  },
  {
    href: "/stores",
    label: "Stores",
  },
  {
    href: "/rebates",
    // label: "Mail-In Rebate Offers",
    label: "Rebates",
  },
  {
    href: "/outlet",
    label: "Shop Outlet",
  },
  {
    href: "https://airportappliance.ntddigital.com/",
    label: "Mandarin",
  },
  {
    href: "/trade",
    label: "Builders & Trade",
  },
  {
    href: "/bodewell",
    label: "Bodewell",
  } 
];

export const CopyRightFooter = [  
  {
    href: "/privacy-policy-cookie-restriction-mode",
    label: "Privacy Policy",
  },
  {
    href: "/terms-and-conditions",
    label: "Terms and Conditions",
  },
  {
    href: "/accessibility-statement",
    label: "Accessibility",
  }
];
 
// Blog constant section start here
export const Categories = [
  {
    href: "/life-style",
    label: "Life Style",
    totalPost:"9",
    id: 0,
  },
  {
    href: "/laundry",
    label: "Laundry",
    totalPost:"2",
    id: 1,
  },
  {
    href: "/kitchen",
    label: "Kitchen",
    totalPost:"3",
    id: 2,
  },
  {
    href: "/smart-appliances",
    label: "Smart Appliances",
    totalPost:"2",
    id: 3,
  },
  {
    href: "/energy-efficiency",
    label: "Energy Efficiency",
    totalPost:"2",
    id: 4,
  },
  {
    href: "/customer-kitchens",
    label: "Customer Kitchens",
    totalPost:"1",
    id: 5,
  },
  {
    href: "/luxury-appliances",
    label: "Luxury Appliances",
    totalPost:"2",
    id: 6,
  },
  {
    href: "/cooktops",
    label: "Cooktops",
    totalPost:"2",
    id: 7,
  },
]

export const RecentPostsSection = [
  {
    img: BlogImage,
    href: "/top-reasons-buy-refrigerator-airport-appliance",
    label: "Top Reasons to Buy Your Refrigerator from Airport Appliance",
    postDate:"October 01, 2024",
  },
  {
    img: BlogImage,
    href: "/best-whirlpool-refrigerators",
    label: "The Best Whirlpool Refrigerators of 2024: Top Picks for Every Kitchen",
    postDate:"September 27, 2024",
  },
]
export const BlogBrands = [
  {
    href: "/Amana",
    label: "Amana",
    id: 0,
  },
  {
    href: "/Asko",
    label: "Asko",
    id: 1,
  },
  {
    href: "/Avanti",
    label: "Avanti",
    id: 2,
  },
  {
    href: "/Beko",
    label: "Beko",
    id: 3,
  },
  {
    href: "/Best",
    label: "Best",
    id: 4,
  },
  {
    href: "/Bertazzoni",
    label: "Bertazzoni",
    id: 5,
  },
  
  {
    href: "/BlueStar",
    label: "BlueStar",
    id: 6,
  },
  {
    href: "/Bosch",
    label: "Bosch",
    id: 7,
  },
  {
    href: "/Broan",
    label: "Broan",
    id: 8,
  },
  {
    href: "/Broil King BBQ",
    label: "Broil King BBQ",
    id: 9
  },
  {
    href: "/Cafe",
    label: "Cafe",
    id: 10
  },
  {
    href: "/Cove",
    label: "Cove",
    id: 11
  },
  {
    href: "/Dacor",
    label: "Dacor",
    id: 12
  },
  {
    href: "/DCS",
    label: "DCS",
    id: 13
  },
  {
    href: "/Electrolux",
    label: "Electrolux",
    id: 14
  },
  {
    href: "/Elica",
    label: "Elica",
    id: 15
  },
  {
    href: "/Fisher & Paykel",
    label: "Fisher & Paykel",
    id: 16
  },
  {
    href: "/Forno",
    label: "Forno",
    id: 17
  },
  {
    href: "/Foster",
    label: "Foster",
    id: 18
  },
  {
    href: "/Foster",
    label: "Foster",
    id: 19
  },
  {
    href: "/Frigidaire",
    label: "Frigidaire",
    id: 20
  },
  {
    href: "/Gaggenau",
    label: "Gaggenau",
    id: 21
  },
  {
    href: "/GE",
    label: "GE",
    id: 22
  },
  {
    href: "/Haier",
    label: "Haier",
    id: 23
  },
  {
    href: "/Hotpoint Appliances",
    label: "Hotpoint Appliances",
    id: 24
  },
  {
    href: "/Jennair",
    label: "Jennair",
    id: 25
  },
  {
    href: "/KitchenAid",
    label: "KitchenAid",
    id: 26
  },
  {
    href: "/LG",
    label: "LG",
    id: 27
  },
  {
    href: "/Liebherr",
    label: "Liebherr",
    id: 28
  },
  {
    href: "/Marvel Refrigeration",
    label: "Marvel Refrigeration",
    id: 29,
  },
  {
    href: "/Maytag",
    label: "Maytag",
    id: 30
  },
  {
    href: "/Miele",
    label: "Miele",
    id: 31
  },
  {
    href: "/Monogram",
    label: "Monogram",
    id: 32
  },
  {
    href: "/Perlick",
    label: "Perlick",
    id: 33
  },
  {
    href: "/Premier",
    label: "Premier",
    id: 34
  },
  {
    href: "/Samsung",
    label: "Samsung",
    id: 35
  },
  {
    href: "/Sharp",
    label: "Sharp",
    id: 36
  },
  {
    href: "/Signature",
    label: "Signature",
    id: 37
  },
  {
    href: "/Speed Queen",
    label: "Speed Queen",
    id: 38
  },
  {
    href: "/Summit",
    label: "Summit",
    id: 39
  },
  {
    href: "/Thermador",
    label: "Thermador",
    id: 40
  },
  {
    href: "/Thor Kitchen",
    label: "Thor Kitchen",
    id: 41
  },
  {
    href: "/True Residential",
    label: "True Residential",
    id: 42
  },
  {
    href: "/Uline",
    label: "Uline",
    id: 43
  },
  {
    href: "/Unique Appliances",
    label: "Unique Appliances",
    id: 44
  },
  {
    href: "/Vent A Hood",
    label: "Vent A Hood",
    id: 45
  },
  {
    href: "/Viking",
    label: "Viking",
    id: 46
  },
  {
    href: "/Whirlpool",
    label: "Whirlpool",
    id: 47
  },
  {
    href: "/Zephyr",
    label: "Zephyr",
    id: 48
  },
  {
    href: "/Zline",
    label: "Zline",
    id: 49
  }
]

export const BlogArchive = [
  {
    href: "/2024-09",
    label: "December 2024",
  },
  {
    href: "/2024-09",
    label: "November 2024",
  },
  {
    href: "/2024-09",
    label: "October 2024",
  },
  {
    href: "/2024-09",
    label: "September 2024",
  },
  {
    href: "/2024-09",
    label: "August 2024",
  },
  {
    href: "/2024-09",
    label: "July 2024",
  },
  
  {
    href: "/2024-09",
    label: "June 2024",
  },
  {
    href: "/2024-09",
    label: "May 2024",
  },
  {
    href: "/2024-09",
    label: "March 2024",
  }
]

export const BlogTags = [
  {
    href: "/kitchen-appliances",
    label: "kitchen appliances",
  },
  {
    href: "/category/laundry",
    label: "Kitchen Appliance brands",
  },
  {
    href: "/category/kitchen",
    label: "Refrigerator Washer and Dryer Sets Ranges",
  },
  {
    href: "/category/smart-appliances",
    label: "BoschDiswasher",
  }
]
// Blog constant section end here

// Social Media Links JSON
export const socialMediaLinks = [
  {
    href: "https://www.facebook.com/airporthomeappliance/",
    imgSrc: FBIcon,
    alt: "Facebook",
  },
  {
    href: "https://twitter.com/airportapplianc/",
    imgSrc: Xcon,
    alt: "Twitter",
  },
  {
    href: "https://www.instagram.com/airportappliance/",
    imgSrc: Instacon,
    alt: "Instagram",
  },
  {
    href: "https://www.linkedin.com/company/airport-home-appliance/",
    imgSrc: InIcon,
    alt: "LinkedIn",
  },
  {
    href: "https://www.youtube.com/user/airportappliance/",
    imgSrc: YTcon,
    alt: "YouTube",
  },
];

export const ManualPlpImages = {
  DLE8400BE,
PTD70EBPTDG,
PTW705BPTDG,
WGB246AXUC,
WGB24600UC,
WQB245AXUC,
WQB245B0UC,
WT8400CB,
//  "PTW705BPTDG-PTD70EBPTDG":PTW705BPTDG_PTD70EBPTDG,
// "WGB246AXUC-WQB245AXUC":WGB246AXUC_WQB245AXUC,
// "WGB24600UC-WQB245B0UC":WGB24600UC_WQB245B0UC,
// "WT8400CB-DLE8400BE":WT8400CB_DLE8400BE,
}


